import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from '../../header/header';
import './settings-page.scss';

const SettingsPage = ({
  allowed = true,
  backTo,
  children,
  feedback,
  onCloseFeedback,
  beforeContent,
}) => {
  const { t } = useTranslation();

  if (!allowed) return <Navigate to="/login" replace />;

  return (
    <div className="App">
      <Header />
      <main>
        {beforeContent}
        <section className="settings">
          <div className="inner">
            {backTo && (
              <Link to={backTo} className="back-button">
                <span className="icon-chevron-left"></span> {t('common-back')}
              </Link>
            )}
            <h2>{t('account-settings-title')}</h2>
            <p>{t('account-settings-description')}</p>
            {children}
          </div>
        </section>
      </main>
      <Snackbar
        open={Boolean(feedback?.open)}
        autoHideDuration={2500}
        onClose={onCloseFeedback}
      >
        <Alert severity={feedback?.severity || 'success'} sx={{ width: '100%' }}>
          {feedback?.message || ''}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SettingsPage;
